import { Button } from 'primereact/button';
import { classNames } from 'primereact/utils';
import { useTranslation } from 'react-i18next';

import SearchBar from '../../../../../../../../components/search-bar/SearchBar';
import useDialogContext from '../../../../../../../../hooks/dialog/useDialogContext';
import { useProductTasksTableQueryParams } from '../../../../../../../../hooks/useProductTasksTableQueryParams';
import StatusFilter from '../../../../../../../../shared/components/status-filter/StatusFilter';
import { PCFRequestStatus } from '../../../../../../../../shared/enums/pcf-request';
import { serializeMulti } from '../../../../../../../../shared/helpers/url-parameter-parser';

export const ALLOWED_PRODUCT_TASK_STATUSES = [PCFRequestStatus.Pending, PCFRequestStatus.Complete];

export const COMPLETE_STATUS_MAPPING = [
  PCFRequestStatus.Complete,
  PCFRequestStatus.Updated,
  PCFRequestStatus.Outdated,
  PCFRequestStatus.Rejected,
];

const ProductTasksTableHeader = () => {
  const { setParams, filters } = useProductTasksTableQueryParams();

  const { t } = useTranslation();
  const { openDialog } = useDialogContext();

  const onSearchChange = (value: string) => {
    setParams({ search: value, page: 1 });
  };

  const onClickExportProductTasks = () => {
    openDialog('export-product-tasks-dialog');
  };

  const onStatusFilterChange = (selectedStatuses: string[]) => {
    setParams({
      status: serializeMulti(selectedStatuses),
      page: 1,
    });
  };

  return (
    <div className='flex flex-column gap-2'>
      <div className='flex flex-column md:flex-row w-full justify-content-end'>
        <Button
          className='justify-content-center'
          onClick={onClickExportProductTasks}
          label={t('tasksPage.tabs.productTasksTab.buttons.exportTasks')}
        />
      </div>
      <div className={classNames('flex justify-content-end align-items-center flex-wrap gap-2')}>
        <div className='flex w-full md:w-auto align-items-center justify-content-between'>
          <label className='hidden xl:block mr-2'>{t('componentsPage.filters')} </label>

          <div className='flex flex-column md:flex-row w-full md:mb-0'>
            <StatusFilter
              onStatusFilterChange={onStatusFilterChange}
              filters={filters}
              allowedStatuses={ALLOWED_PRODUCT_TASK_STATUSES}
            />
          </div>
        </div>

        <SearchBar onSearchChange={onSearchChange} initialValue={filters.search} />
      </div>
    </div>
  );
};

export default ProductTasksTableHeader;
